// extracted by mini-css-extract-plugin
module.exports = {"card":"_025a50318d--card--3pPR3","title":"_025a50318d--title--1zToA","button":"_025a50318d--button--37YfM"};